import { Box, Card, Grid, Group, Text } from '@mantine/core';
import { IconThumbDown, IconThumbUp } from '@tabler/icons-react';
import HeaderStatistic from '../HeaderStatistic';
import MetricsSelector from '../MetricsSelector';
import Spinner from '../Spinner';

const STATIC_ID = 1;

// Same look as HeaderStatistic; feedback is a flat { up, down } (older APIs omit it).
const FeedbackStatistic = ({ title, count, Icon }) => (
  <Box ta="center">
    <Text size="sm" c="dimmed">
      {title}
    </Text>
    <Group gap={4} justify="center">
      <Icon size={16} aria-hidden />
      <Text>{(Number(count) || 0).toLocaleString(navigator.language)}</Text>
    </Group>
  </Box>
);

const StatsHeader = ({ stats, startDate, endDate, setStartDate, setEndDate, currency }) => {
  const cols = stats?.feedback ? 18 : 14;
  return (
    <>
      <MetricsSelector
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        rowSize="12"
        scope="chatSessions"
      />
      <Card withBorder mt="sm">
        {stats === undefined ? (
          <Spinner />
        ) : (
          <Grid columns={cols}>
            <Grid.Col span={{ base: cols, sm: 2 }}>
              <HeaderStatistic
                title="Unique sessions"
                stats={stats}
                stat="uniqueSessions"
                id={STATIC_ID}
                statKey="count"
              />
            </Grid.Col>
            <Grid.Col span={{ base: cols, sm: 2 }}>
              <HeaderStatistic title="Questions" stats={stats} stat="chatbotQuestions" id={STATIC_ID} statKey="count" />
            </Grid.Col>
            <Grid.Col span={{ base: cols, sm: 2 }}>
              <HeaderStatistic
                title="Products Answers | QA Answers"
                stats={stats}
                stat="productAnswers"
                secondaryStat="qaAnswers"
                id={STATIC_ID}
                statKey="count"
              />
            </Grid.Col>
            <Grid.Col span={{ base: cols, sm: 2 }}>
              <HeaderStatistic
                title="Product Clicks"
                stats={stats}
                stat="salesAgentProductClick"
                id={STATIC_ID}
                statKey="count"
              />
            </Grid.Col>
            <Grid.Col span={{ base: cols, sm: 2 }}>
              <HeaderStatistic
                title="Conversions"
                stats={stats}
                stat="salesAgentConversions"
                percentageOfStat="salesAgentProductClick"
                id={STATIC_ID}
                statKey="count"
              />
            </Grid.Col>
            <Grid.Col span={{ base: cols, sm: 2 }}>
              <HeaderStatistic
                title="Purchases"
                stats={stats}
                stat="salesAgentPurchases"
                percentageOfStat="salesAgentConversions"
                id={STATIC_ID}
                statKey="count"
              />
            </Grid.Col>
            <Grid.Col span={{ base: cols, sm: 2 }}>
              <HeaderStatistic
                title="Revenue"
                stats={stats}
                stat="salesAgentPurchases"
                id={STATIC_ID}
                statKey="value"
                currency={currency}
              />
            </Grid.Col>
            {stats.feedback && (
              <>
                <Grid.Col span={{ base: cols, sm: 2 }}>
                  <FeedbackStatistic title="Thumbs up" count={stats.feedback.up} Icon={IconThumbUp} />
                </Grid.Col>
                <Grid.Col span={{ base: cols, sm: 2 }}>
                  <FeedbackStatistic title="Thumbs down" count={stats.feedback.down} Icon={IconThumbDown} />
                </Grid.Col>
              </>
            )}
          </Grid>
        )}
      </Card>
    </>
  );
};

export default StatsHeader;
